export default "__VITE_ASSET__wVVUjmzc__"